// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oFrp","expireSoon":"styles_expireSoon__2o7nq"};